export const NotFound: React.FC = () => (
  <div className='flex-center'>
    <h2>404</h2>
    <div className='vertical-divider' />
    <p>This page could not be found.</p>
  </div>
);
